
const init = () => {

    var $component = $('.c-events-filter');
    if (!$component.length) return;

    var $eventsList = $('.c-events-list');
    var $eventsContainer = $eventsList.find('.c-events-list__cols');
    var allStatesTotal = $('.c-events-list .c-load-more').attr('data-total');


    var $filterBtns = $component.find('button');
    $filterBtns.on('click', onFilterClick);
    
    function onFilterClick(e) {
        e.preventDefault();
        var $that = $(this);

        // Show loading state
        $eventsList.addClass('is-loading');

        // Handle reset (clicking the same button)
        if ($that.hasClass('is-selected')) {
            $that.removeClass('is-selected');
            loadEvents(); // Load all events
            return;
        }

        // Select the clicked button and deselect others
        $filterBtns.removeClass('is-selected');
        $that.addClass('is-selected');
        
        var filter = $that.find('span').text().toLowerCase();
        
        loadEvents(filter);
    }

    function loadEvents(state = null) {
        var url = window.location.pathname + '?handler=EventList&p=1';
        if (state) {
            url += '&state=' + encodeURIComponent(state);
        }


        $.get(url)
            .done(function(data) {
                var $responseData = $(data);
                var $newEventsContainer = $responseData.find('.c-events-list__cols');
                
                // Check if there are any events in the response
                if ($newEventsContainer.length && $newEventsContainer.find('.c-events-list__col').length > 0) {
                    // Replace the events container content with new events
                    $eventsContainer.html($newEventsContainer.html());
                } else {
                    // No events found - show no results message
                    $eventsContainer.html('<p class="c-events__no-results">No events found.</p>');
                }
                
                // Update the load-more button if it exists
                var $loadMore = $('.c-events-list .c-load-more');
                if ($loadMore.length) {
                    var newTotal = $responseData.find('.c-load-more').attr('data-total');
                    $loadMore.attr('data-total', newTotal);
                    $loadMore.attr('data-next-page', 2);
                    
                    // Disable load-more if no events or all events are shown
                    if (!newTotal || parseInt(newTotal) <= $eventsContainer.find('.c-events-list__col').length) {
                        $loadMore.addClass('is-disabled');
                    } else {
                        $loadMore.removeClass('is-disabled');
                    }
                }
            })
            .fail(function() {
                console.error('Failed to load events');
            })
            .always(function() {
                $eventsList.removeClass('is-loading');
            });
    }
}

export default init;
